import { apiURL } from "../../config";

export async function getCategoryList(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/decision/category.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}
